import { Component, OnChanges, inject, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingResponse} from '../../../model/unit-rating-response';
import {GuruEntity} from '../../../model/guru-entity';
import {SelectionUtils} from '../../selection-utils';
import {UnitConversionUtils} from '../../unit-conversion-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { PerformanceResultsComponent } from '../../common/performance-results/performance-results.component';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-belt-drive-performance-results',
    templateUrl: './belt-drive-performance-results.component.html',
    styleUrls: ['./belt-drive-performance-results.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, PerformanceResultsComponent]
})
export class BeltDrivePerformanceResultsComponent implements OnChanges {
  private userStateService = inject(UserStateService);
  readonly ratingResponse = input.required<UnitRatingResponse>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  airflow = 0;
  standardAirflow = 0;
  brakingHorsepower = 0;
  fullLoadAmps = 0;
  isExpanded = true;
  isMetric = false;
  private sectionKey = ConfigurationSection.PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.clearOutputValues();
    const metricInput = SelectionUtils.getEntity(this.selectionEntities(), 'USMetricInput');
    this.isMetric = metricInput && 'true' === metricInput.Value;
    if (this.ratingResponse()) {
      this.airflow = this.ratingResponse().Airflow;
      this.standardAirflow = this.ratingResponse().StandardAirflow ?? 0;
      const motorHpSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USMotorHP');
      if ('Alternate' === (motorHpSelection?.Value || 'Primary')) {
        this.fullLoadAmps = (this.ratingResponse()?.AlternateCircuit?.FullLoadAmps || 0);
        this.brakingHorsepower = (this.ratingResponse().SecondaryDrivePackage.BrakingHorsepower || 0);
      } else {
        this.fullLoadAmps = (this.ratingResponse()?.CircuitResponse?.FullLoadAmps || 0);
        this.brakingHorsepower = (this.ratingResponse().PrimaryDrivePackage.BrakingHorsepower || 0);
      }
    }
  }

  private clearOutputValues(): void {
    this.airflow = 0;
    this.standardAirflow = 0;
    this.brakingHorsepower = 0;
    this.fullLoadAmps = 0;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  getAirflowMeasurementUnits(isStandard: boolean): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric, isStandard);
  }

}
